/** Configurazione Cognito Managed Login (Amplify v6). */
export const authDisabled =
  import.meta.env.VITE_AUTH_DISABLED === "true" ||
  import.meta.env.VITE_AUTH_DISABLED === "1";

export function cognitoConfigured(): boolean {
  return Boolean(
    import.meta.env.VITE_COGNITO_USER_POOL_ID &&
      import.meta.env.VITE_COGNITO_CLIENT_ID &&
      import.meta.env.VITE_COGNITO_DOMAIN,
  );
}

function cognitoDomainHost(): string {
  const raw = (import.meta.env.VITE_COGNITO_DOMAIN as string | undefined) ?? "";
  return raw.replace(/^https?:\/\//, "").replace(/\/$/, "");
}

/**
 * Pagina login Hosted UI Cognito (dopo logout l'utente atterra qui, non sulla /login dell'app).
 * Senza PKCE: Cognito può mostrare login; il callback OAuth usa comunque Amplify su /auth/callback.
 */
export function cognitoHostedLoginUrl(): string | null {
  if (!cognitoConfigured()) return null;
  const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID as string;
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const q = new URLSearchParams({
    client_id: clientId,
    redirect_uri: `${origin}/auth/callback`,
    response_type: "code",
    scope: "openid email profile",
    lang: "it",
  });
  return `https://${cognitoDomainHost()}/login?${q.toString()}`;
}

/** Invalida sessione SSO e torna all'app su /auth/exit (redirect immediato a Cognito login). */
export function cognitoHostedLogoutUrl(): string | null {
  if (!cognitoConfigured()) return null;
  const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID as string;
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const logoutUri = encodeURIComponent(`${origin}/auth/exit`);
  return `https://${cognitoDomainHost()}/logout?client_id=${encodeURIComponent(clientId)}&logout_uri=${logoutUri}`;
}

export function amplifyAuthConfig() {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return {
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
        userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID as string,
        loginWith: {
          oauth: {
            domain: import.meta.env.VITE_COGNITO_DOMAIN as string,
            scopes: ["openid", "email", "profile"],
            redirectSignIn: [`${origin}/auth/callback`],
            redirectSignOut: [`${origin}/auth/exit`],
            responseType: "code" as const,
          },
        },
      },
    },
  };
}
